import { Routes } from '@angular/router';

import { Producto } from './producto/producto'; // Componente Productos
import { Contacto } from './contacto/contacto'; // Componente Contacto
import { Login } from './login/login'; // Componente Login
import { Dasboard } from './dasboard/dasboard'; // Componente Dasboard
import { authGuard } from './guards/auth.guard'; // Protege el acceso al dashboard
import { Inicio } from './inicio/inicio';

export const routes: Routes = [
  { path: '', redirectTo: 'inicio', pathMatch: 'full' },
  { path: '', component: Inicio },

  { path: 'producto', component: Producto },
  { path: 'contacto', component: Contacto },
  { path: 'login', component: Login },
  {
    path: 'dasboard',
    component: Dasboard,
    canActivate: [authGuard],
  },
  { path: '**', redirectTo: '' },
];
